import React from 'react';

import { useSuperHubStore } from '@core/store';

import EmptyState from '@routes/SuperHub/components/EmptyState';

/**
 * @todo render different empty states for admin vs user.
 */
export default function EmptyChangelog() {
  const isEditable = useSuperHubStore(s => s.user.role === 'admin' || s.user.role === 'editor');

  return <EmptyState action={isEditable ? '/create/changelog' : undefined} section="changelog" />;
}
